<template>
  <div class="user-setting-main" :style="iosOrAndroidStyle">

    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title="设置"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />

    <item name="账号设置" @click="routeTo(isIos ? '/account/users' : '/account/vue_users')" :placeholder="false"/>
    <item v-if="canRecommend" name="隐私设置" @click="routeTo('/account/privacy')" :placeholder="false"/>

    <button @click="signOut" v-if="!isQuickApp && !isAlipayClient && !isToutiao && !isQuaReClient && !isUCClient">退出</button>
  </div>
</template>
<script>
import { envMixin } from '../../assets/js/mixin/global';
import { updateJWT, toLogin } from '@/assets/js/utils';
import { userMixin } from '@/assets/js/mixin/user';
import { componentsMixin } from '../../assets/js/mixin/components'
import Cookies from "js-cookie";
import WNavBar from "@/components/global/w-navbar";
import Item from './components/item';
import { mapState, mapActions } from 'vuex'
export default {
  name: 'UserSetting',
  mixins: [ envMixin, componentsMixin, userMixin ],
  components: {
    WNavBar,
    Item
  },
  data() {
    return {
      onlineData: {}, // 在线简历数据
    };
  },
  async mounted() {
    // 获取在先简历
  },
  computed: {
    ...mapState('cvIndex', ['cvList']),
    canRecommend() {
      const list = this.cvList.filter(item => item.can_editable && item.lang === 'cn' && !item.is_mentor)
      return !!list.length
    }
  },
  methods: {
    ...mapActions('cvIndex', ['getCvList']),
    leftBtnClick() {
      this.$router.back();
    },
    async signOut () {
      this.$createDialog({
        title: '提示',
        type: 'confirm',
        content: '确定退出登录吗？',
        onConfirm: () => {
          if (this.isIos) {
            setupWebViewJavascriptBridge((bridge) => {
              bridge.callHandler('signOut', {},
                function responseCallback (responseData) {
                })
            })
          } else if (this.isHarmony) {
            Cookies.remove('_t')
            Cookies.remove('_t_at')
            Cookies.remove('_t_plugin')
            Cookies.remove('_t_plugin_at')
            
            toLogin(process.env.VUE_APP_HOST + '/account/users/index');
          } else if (this.isWxMini) {
            // this.$wechat.mini_program.removeStorageSync('unionid')
            // this.$wechat.mini_program.removeStorageSync('Authorization')
            Cookies.remove('_t', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_plugin', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_plugin_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            this.$wechat.miniProgram.redirectTo({
              url: `/pages/login/login`
            })
          } else {
            Cookies.remove('_t', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_plugin', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            Cookies.remove('_t_plugin_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
            
            toLogin(process.env.VUE_APP_HOST + '/account/users/index');
            // let res = await this.$api.user.signOut({})
            // if (res.code === 1000) {
            //   updateJWT({}, true)
            //   window.location.href = process.env.VUE_APP_LINK + '/signin/?type=login';
            // }
            // else {
            //   this.showToast('请重试');
            // }
          }
        }
      }).show()
		},
    getCvList() {
      if (!this.cvList.length) {
        this.getCvList()
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.user-setting-main {
  padding-top: 44px;
  button {
    width: 343px;
    height: 42px;
    background: #CFCFCF;
    border: none;
    border-radius: 4px;
    position: fixed;
    bottom: 18px;
    left: 16px;
    font-size: 16px;
    color: #fff;
    &.active {
      background: #FF4F4C;
      color: #fff;
    }
  }
}
</style>
